// React Core
import {Refine} from "@pankod/refine-core";
import routerProvider from "@pankod/refine-react-router-v6";
import {useTranslation} from "react-i18next";

// Project Providers
import {authProvider} from "./authProvider";
import dataProvider from "./dataProvider";

// Ant-Design
import {AreaChartOutlined} from "@ant-design/icons"
import {Layout, notificationProvider,} from "@pankod/refine-antd";
import "styles/antd.less";

// Fa-Icon
import {library} from '@fortawesome/fontawesome-svg-core'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'

// Pages
import {LoginPage} from "pages/login/index.d"
import {EventCreate, EventEdit, EventList} from "pages/events";
import {AgendaCreate, AgendaEdit, AgendaList} from "pages/agendas";
import {RoomEdit, RoomList, RoomShow, RoomCreate} from "pages/rooms";
import {PriceZoneList, PriceZoneCreate, PriceZoneEdit} from "pages/pricezones";
import {YieldanalysisCreate, YieldanalysisEdit, YieldAnalysisList} from "pages/yieldanalysis";
import {UserCreate, UserEdit, UserList} from "pages/users";
import {Footer, Header, Sider, Title,} from "components/layout";

function App() {
    const {t, i18n} = useTranslation();

    const i18nProvider = {
        translate: (key: string, params: object) => t(key, params),
        changeLocale: (lang: string) => i18n.changeLanguage(lang),
        getLocale: () => i18n.language,
    };

    return (
        <Refine
            routerProvider={routerProvider}
            notificationProvider={notificationProvider}
            dataProvider={dataProvider(`${process.env?.REACT_APP_API_URL || ''}`)}
            authProvider={authProvider}
            LoginPage={LoginPage}
            // mutationMode="pessimistic"
            resources={[
                {
                    name: "pricezones",
                    icon: <AreaChartOutlined/>,
                    options: {
                        route: encodeURI(t("menu.pricezones")),
                    },
                    list: PriceZoneList,
                    create: PriceZoneCreate,
                    edit: PriceZoneEdit,
                },
                {
                    name: "agendas",
                    options: {
                        route: encodeURI(t("menu.agendas"))
                    },
                    list: AgendaList,
                    create: AgendaCreate,
                    edit: AgendaEdit,
                },
                {
                    name: "events",
                    options: {
                        route: encodeURI(t("menu.events"))
                    },
                    list: EventList,
                    create: EventCreate,
                    edit: EventEdit,
                },
                {
                    name: "rooms",
                    parentName: "products",
                    options: {
                        route: encodeURI(t("menu.rooms")),
                    },
                    list: RoomList,
                    show: RoomShow,
                    create: RoomCreate,
                    edit: RoomEdit,
                },
                {
                    name: "yieldanalysis",
                    icon: <AreaChartOutlined/>,
                    options: {
                        route: encodeURI(t("menu.yield")),
                    },

                    list: YieldAnalysisList,
                    create: YieldanalysisCreate,
                    edit: YieldanalysisEdit,
                },
                {
                    name: "users",
                    options: {
                        route: encodeURI(t("menu.users")),
                    },
                    list: UserList,
                    edit: UserEdit,
                    create: UserCreate,
                },
            ]}
            Title={Title}
            Header={Header}
            Sider={Sider}
            Footer={Footer}
            Layout={Layout}
            i18nProvider={i18nProvider}
        />
    );
}

export default App;
library.add(fab, fas, far)
